import { useNavigate } from '@reach/router';
import { useDispatch, useSelector } from 'react-redux';
import { basepathSelector } from 'src/redux/app/selectors';
import { resetBike } from 'src/redux/bike/actions';
import { resetConfigurator, closeAllModals } from 'src/redux/configurator/actions';
import { modalPropsSelector } from 'src/redux/configurator/selectors';
import { clearLoadedConfiguration } from 'src/redux/garage/actions';
import { resetTagging } from 'src/redux/tagging/actions';
import useDataLayer from './useDataLayer';

export default function useLeaveConfigurator() {
  const pushToDataLayer = useDataLayer();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const basepath = useSelector(basepathSelector);

  const modalProps = useSelector(modalPropsSelector('reset')) || {};
  const { search, link, onReset } = modalProps;

  return () => {
    // Search form in the header
    const searchForm = document.querySelector('.search-form');

    pushToDataLayer('configuratorResetConfirm');

    dispatch(resetConfigurator());
    dispatch(resetBike());
    dispatch(resetTagging());
    dispatch(clearLoadedConfiguration());
    dispatch(closeAllModals());

    if (link) {
      document.location = link;
      return;
    }

    if (typeof onReset === 'function') {
      onReset();
      return;
    }

    if (search) {
      searchForm.submit();
      return;
    }

    navigate(basepath);
  };
}
